// Fixed workbook fields for the three implemented asset pages.
export const machiningFields = {
    machines: {
        number: 'machine',
        numberLabel: 'Machine No.',
        singular: 'machine',
        plural: 'machines',
        categoryTitle: 'Machine categories',
        required: [
            'machine',
            'name',
            'category',
            'manufacturer',
            'model',
            'location',
            'responsibleDepartment',
            'assetCondition',
            'maintenanceRequirement',
        ],
    },
    testers: {
        number: 'testerNo',
        numberLabel: 'Tester No.',
        singular: 'tester',
        plural: 'testers',
        categoryTitle: 'Tester categories',
        required: [
            'testerNo',
            'name',
            'category',
            'manufacturer',
            'model',
            'location',
            'responsibleDepartment',
            'assetCondition',
            'maintenanceRequirement',
        ],
    },
    'jig-fixtures': {
        number: 'jigFixNo',
        numberLabel: 'Jig & Fixture No.',
        singular: 'jig & fixture',
        plural: 'jigs & fixtures',
        categoryTitle: 'Jig & Fixture categories',
        required: [
            'jigFixNo',
            'name',
            'category',
            'location',
            'responsibleDepartment',
            'assetCondition',
            'maintenanceRequirement',
        ],
    },
};

export const conditions = ['OK', 'NG', 'Under Repair', 'End of Life'];

export const textFields = [
    ['assetNo', 'Asset No.', 100],
    ['name', 'Name', 100],
    ['equipmentDescription', 'Equipment description', 200],
    ['manufacturer', 'Manufacturer', 100],
    ['model', 'Model', 100],
    ['serialNo', 'Serial No.', 100],
    ['location', 'Location', 200],
    ['responsibleDepartment', 'Responsible department', 100],
    ['serviceProvider', 'Service provider', 200],
];

export function missingDetails(kind, row) {
    return machiningFields[kind].required.some(
        (field) => row[field] === null || row[field] === undefined || row[field] === ''
    );
}
